import { LOCALES, REGIONS } from 'state/intl/types';

// fr prices: 1,00$ -> 1,00 $
const addSpaceBetweenDigitsAndDollarSign = (price: string) => price.replace(/([0-9])(\$)/, '$1 $2');

// en prices $1.00 -> $ 1.00
const addSpaceBetweenDollarSignAndDigits = (price: string) => price.replace(/(\$)([0-9])/, '$1 $2');

// fr prices with currency: 1,00 $ US ->  1,00 $US
const removeExtraSpaceBetweenDollarSignAndCurrency = (price: string) =>
  price.replace(/(\$)\s([A-Z]{2})$/, '$1$2');

// pipe these two together to fix the Reload Timcard button
const frCombined = (price: string) =>
  removeExtraSpaceBetweenDollarSignAndCurrency(addSpaceBetweenDigitsAndDollarSign(price));

// configure formatting functions for each combination
const config = {
  [REGIONS.CA]: {
    [LOCALES.en_ca]: addSpaceBetweenDollarSignAndDigits,
    [LOCALES.en_us]: addSpaceBetweenDollarSignAndDigits,
    [LOCALES.fr_ca]: frCombined
  },
  [REGIONS.US]: {
    [LOCALES.en_ca]: addSpaceBetweenDollarSignAndDigits,
    [LOCALES.en_us]: addSpaceBetweenDollarSignAndDigits,
    [LOCALES.fr_ca]: frCombined
  }
};

/**
 * Add spaces between currency names and values
 * @param region {REGIONS} - the home country of the website
 * @param locale {LOCALES} - the locale of the current customer
 * @param price {string} - a price without our extra formatting e.g. US$1.76
 * @returns a price, possibly with more spaces - e.g. US$ 1.76
 */
export const adjustCurrencySpacing = (region: string, locale: LOCALES, price: string) => {
  const formattingFunction = config[region.toUpperCase()]?.[locale];

  return formattingFunction ? formattingFunction(price) : price;
};
